import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiBell, FiCheck } from 'react-icons/fi';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Netlify Forms submission
    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          'form-name': 'newsletter',
          'email': email
        }).toString()
      });

      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      }
    } catch (error) {
      console.error('Newsletter submission error:', error);
    }

    setIsSubmitting(false);
  };

  return (
    <div className="container-custom px-6">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="max-w-2xl mx-auto text-center"
      >
        <div className="bg-navy text-white rounded-2xl p-8 md:p-12 shadow-lg">
          {!isSubmitted ? (
            <>
              <FiBell className="text-gold text-4xl mx-auto mb-4" />
              <h3 className="text-2xl font-serif mb-4">
                Get notified when new insights are published
              </h3>
              <p className="text-gray-300 mb-8">
                Join the journey. No spam, just thoughtful content about building with empathy.
              </p>

              <form 
                onSubmit={handleSubmit}
                name="newsletter"
                method="POST"
                data-netlify="true"
                className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto"
              >
                <input type="hidden" name="form-name" value="newsletter" />
                
                <input
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="flex-grow px-4 py-3 rounded-lg text-navy focus:ring-2 focus:ring-gold focus:outline-none"
                />
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`bg-gold text-navy px-6 py-3 rounded-lg font-medium transition-all duration-300 hover:bg-light-gold ${
                    isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105'
                  }`}
                >
                  {isSubmitting ? 'Subscribing...' : 'Notify Me'}
                </button>
              </form>

              <p className="text-xs text-gray-400 mt-4">
                Your privacy matters. Unsubscribe anytime.
              </p>
            </>
          ) : (
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.4 }}
            >
              <FiCheck className="text-gold text-5xl mx-auto mb-4" />
              <h3 className="text-2xl font-serif mb-4">
                You're on the list!
              </h3>
              <p className="text-gray-300">
                Thank you for subscribing. I'll notify you when new insights are published.
              </p>
            </motion.div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default NewsletterSignup;